import { apiAxios, authApiAxiosWithRefresh } from './customAxios';


interface GetMakesParams {
    [key: string]: any;
    isClassifieds?: boolean;
}

export const getMakes = async (params: GetMakesParams) => {
    const { isClassifieds, ...otherParams } = params;

    const data = {
        ...otherParams,
        isClassifieds
    }

    try {
        const response = await (
            await authApiAxiosWithRefresh()
        ).post('/get_makes', data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data
    } catch (error) {
        console.error('Error posting data:', error);
    }
};



export const getModels = async (params: GetMakesParams) => {
    const { isClassifieds, ...otherParams } = params;

    const data = {
        ...otherParams,
        isClassifieds
    }

    try {
        const response = await (
            await authApiAxiosWithRefresh()
        ).post('/get_models', data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data
    } catch (error) {
        console.error('Error posting data:', error);
    }
};

export const getWebsites = async (params: GetMakesParams) => {
    const { isClassifieds, ...otherParams } = params;

    const data = {
        ...otherParams,
        isClassifieds
    }

    try {
        const response = await (
            await authApiAxiosWithRefresh()
        ).post('/get_websites', data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        // Transform website names in the response
        const transformedWebsites = response.data.map((website: string) => {
            switch (website) {
                case 'eBay Motors':
                    return 'eBay Motors';
                case 'Cars and Bids':
                    return 'Cars and Bids';
                case 'Bring a Trailer':
                    return 'Bring a Trailer';
                case 'Hagerty Marketplace':
                    return 'Hagerty Marketplace';
                case 'PCARMARKET':
                    return 'PCARMARKET';
                case 'The MB Market':
                    return 'The MB Market';
                default:
                    return website;
            }
        });

        const uniqueWebsites = transformedWebsites.filter(
            (website: string, index: number, self: string[]) => self.indexOf(website) === index
        );

        return uniqueWebsites;
    } catch (error) {
        console.error('Error posting data:', error);
    }
};



